import { CToast, CToastBody, CToastClose, CToaster } from '@coreui/react-pro'
import React, { useEffect, useMemo, useRef, useState } from 'react'

const initState = {
  visible: false,
  message: '',
  color: '',
}

const UseToastAlert = (props = {}) => {
  const [toast, addToast] = useState(null)
  const [placement, setPlacement] = useState('bottom-end')
  const [state, setState] = useState({ ...initState, ...props })
  const toaster = useRef()
  const showToast = (props = {}) => {
    setState({
      ...initState,
      ...props,
    })
    setPlacement(props?.placement ? props.placement : 'bottom-end')
  }

  useEffect(() => {
    if (state.visible) {
      displayToast()
    }
  }, [state])

  const displayToast = () => {
    let notificationToast = (
      <CToast
        autohide={true}
        visible={true}
        color={state.color}
        className="text-white align-items-center"
      >
        <div className="d-flex">
          <CToastBody>{state.message}</CToastBody>
          <CToastClose className="me-2 m-auto" white />
        </div>
      </CToast>
    )
    addToast(notificationToast)
    setState(initState)
  }

  const toastAlert = useMemo(() => {
    const alertComponent = () => {
      return <CToaster ref={toaster} push={toast} placement={placement} />
    }
    return alertComponent
  }, [state, placement])

  return [toastAlert, showToast]
}

export default UseToastAlert
